module.exports = __webpack_public_path__ + "img/ad4.24c5dccd.jpg";